/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Faq_Q2Inputs */

const en_diff_faq_q2 = /** @type {(inputs: Diff_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it compare nested objects?`)
};

const ko_diff_faq_q2 = /** @type {(inputs: Diff_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중첩된 객체도 비교하나요?`)
};

const ja_diff_faq_q2 = /** @type {(inputs: Diff_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネストされたオブジェクトも比較しますか？`)
};

/**
* | output |
* | --- |
* | "Does it compare nested objects?" |
*
* @param {Diff_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_faq_q2 = /** @type {((inputs?: Diff_Faq_Q2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Faq_Q2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_faq_q2(inputs)
	if (locale === "ko") return ko_diff_faq_q2(inputs)
	return ja_diff_faq_q2(inputs)
});